import MainNav from '../components/MainNav';
import MainFooter from '../components/MainFooter';
import { Button } from '../components/ui/button';
import { ExternalLink, Linkedin, Globe } from 'lucide-react';

const FOUNDER_PHOTO = "https://customer-assets.emergentagent.com/job_member-hub-104/artifacts/dn2b2ve3_image.png";

const FounderPage = () => {
    return (
        <div className="min-h-screen bg-[#3D4435]">
            <MainNav />
            
            <main className="pt-32 pb-24 px-6">
                <div className="max-w-5xl mx-auto">
                    {/* Header */}
                    <div className="text-center mb-16">
                        <p className="text-[#C9A227] text-sm uppercase tracking-[0.2em] font-medium mb-4">
                            Meet the Founder
                        </p>
                        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white font-['Playfair_Display'] mb-6">
                            Dr. Herman I. Pryor Jr., Ed.D.
                        </h1>
                        <p className="text-[#A0A0A0] text-lg max-w-2xl mx-auto">
                            Visionary leader, educator, and advocate for Black men's mental wellness
                        </p>
                    </div>

                    {/* Main Content */}
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
                        {/* Photo */}
                        <div className="lg:col-span-5">
                            <div className="sticky top-32">
                                <div className="relative">
                                    <div className="absolute -inset-4 bg-gradient-to-br from-[#C9A227]/20 to-transparent rounded-2xl blur-xl" />
                                    <img 
                                        src={FOUNDER_PHOTO}
                                        alt="Dr. Herman I. Pryor Jr."
                                        className="relative rounded-2xl w-full object-cover shadow-2xl"
                                    />
                                </div>
                                
                                {/* Links */}
                                <div className="mt-6 flex flex-wrap gap-3">
                                    <Button
                                        variant="outline"
                                        className="border-[#C9A227] text-[#C9A227] hover:bg-[#C9A227] hover:text-[#3D4435]"
                                        onClick={() => window.open('https://www.linkedin.com/in/peopleequityinvestor/', '_blank')}
                                        data-testid="founder-linkedin-btn"
                                    >
                                        <Linkedin className="w-4 h-4 mr-2" />
                                        LinkedIn
                                    </Button>
                                    <Button
                                        variant="outline"
                                        className="border-[#C9A227] text-[#C9A227] hover:bg-[#C9A227] hover:text-[#3D4435]"
                                        onClick={() => window.open('https://www.hipenterprise.com/', '_blank')}
                                        data-testid="founder-website-btn"
                                    >
                                        <Globe className="w-4 h-4 mr-2" />
                                        Website
                                    </Button>
                                </div>
                            </div>
                        </div>

                        {/* Bio Content */}
                        <div className="lg:col-span-7 space-y-8">
                            <div className="bg-[#4A5240] rounded-2xl p-8 border border-[#5A6350]">
                                <h2 className="text-2xl font-bold text-white font-['Playfair_Display'] mb-6">
                                    About Dr. Pryor
                                </h2>
                                <div className="space-y-6 text-[#A0A0A0] leading-relaxed">
                                    <p>
                                        The Recovery Room was founded in 2023 with a singular purpose: to create a safe, intentional space where Black men can heal and build meaningful community.
                                    </p>
                                    <p>
                                        With a background spanning counseling, behavioral and organizational psychology, leadership development, change management, adult education, and workforce transformation, Dr. Pryor brings a thoughtful blend of compassion, vision, and expertise to advancing the mission of supporting Black men in becoming the best versions of themselves.
                                    </p>
                                    <p>
                                        Dr. Pryor's work is driven by a deep understanding that too often, Black men shoulder the world's expectations without a space to release, reset, or simply be. The Recovery Room was created to change that narrative.
                                    </p>
                                </div>
                            </div>

                            <div className="bg-[#4A5240] rounded-2xl p-8 border border-[#5A6350]">
                                <h2 className="text-2xl font-bold text-white font-['Playfair_Display'] mb-6">
                                    Areas of Expertise
                                </h2>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    {[
                                        'Counseling & Psychology',
                                        'Leadership Development',
                                        'Change Management',
                                        'Adult Education',
                                        'Workforce Transformation',
                                        'Organizational Behavior',
                                        'Community Building',
                                        'Mental Wellness'
                                    ].map((expertise, idx) => (
                                        <div 
                                            key={idx}
                                            className="flex items-center gap-3 p-3 bg-[#3D4435] rounded-lg"
                                        >
                                            <div className="w-2 h-2 rounded-full bg-[#C9A227]" />
                                            <span className="text-white text-sm">{expertise}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="bg-gradient-to-br from-[#C9A227]/20 to-[#C9A227]/5 rounded-2xl p-8 border border-[#C9A227]/30">
                                <p className="text-xl text-white font-['Playfair_Display'] italic leading-relaxed">
                                    "My vision is to improve the overall mental wellness of Black men, one room and one experience at a time."
                                </p>
                                <p className="text-[#C9A227] mt-4 font-medium">— Dr. Herman I. Pryor Jr.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <MainFooter />
        </div>
    );
};

export default FounderPage;
